import React from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import { useTranslation } from 'react-i18next';

import { ButtonLink } from 'common/components/buttons/ButtonLink';

import { IAvailableStore } from '../../types';
import { AddressDetails } from '../AddressDetails';

interface IProps {
    appointment?: boolean;
    className?: string;
    hideDistance?: boolean;
    store: IAvailableStore;
    onClick(): void;
}

const BaseStoreCard: React.FC<IProps> = ({
    appointment,
    className,
    hideDistance,
    store: { city, address, distanceKm },
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <div className={className} onClick={appointment ? undefined : onClick}>
            {appointment && (
                <Box height="25px" mr={2}>
                    <CheckOutlinedIcon className="checkIcon" />
                </Box>
            )}

            <AddressDetails
                address={address}
                city={city}
                distanceKm={distanceKm}
                hideDistance={hideDistance}
            />

            <Box
                height={appointment ? 'auto' : '25px'}
                ml="auto"
                mt={appointment ? 'auto' : 0}
            >
                {appointment ? (
                    <ButtonLink className="editButton" onClick={onClick}>
                        <Typography className="editText">
                            {t('appointment.change')}
                        </Typography>
                    </ButtonLink>
                ) : (
                    <ArrowForwardOutlinedIcon className="arrowIcon" />
                )}
            </Box>
        </div>
    );
};

interface IStyledProps {
    selected?: boolean;
}

export const StoreCard = styled(BaseStoreCard)<IStyledProps>`
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.palette.primary.light};
    border-radius: 5px;
    cursor: ${({ appointment }) => !appointment && 'pointer'};
    padding: ${({ theme }) => `${theme.spacing(3)}px`};
    margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
    border: 2px solid transparent;
    color: ${({ theme }) => theme.palette.primary.contrastText};

    :hover {
        border: ${({ theme }) => `2px solid ${theme.palette.primary.main}`};
    }

    .checkIcon {
        width: 25px;
        height: 25px;
        color: ${({ theme }) => theme.palette.primary.main};
    }

    .arrowIcon {
        width: 25px;
        height: 25px;
        color: ${({ theme }) => theme.palette.primary.main};
        position: relative;
        right: -4px;
    }

    .editButton {
        text-decoration: none;
    }

    .editText {
        font-size: 1rem;
    }
`;
